import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { SuccessItemModel } from '@libs/form/models';
import { BypassSecurityPipe } from '@libs/shared/ui';
import { ItemBaseComponent } from '../../../models';

@Component({
  selector: 'ui-form-success',
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IconComponent,
    BypassSecurityPipe,
  ],
})
export class SuccessComponent extends ItemBaseComponent {
  @Input() public data!: SuccessItemModel;
}
